import cookies from 'react-cookies';

export const getCookies = (key: string): string | undefined => {
  return cookies.load(key);
};

export const setCookies = (
  key: string,
  value: string,
  opts?: { domain?: string },
) => {
  // @ts-ignore
  if (import.meta.env.DEV) {
    delete opts?.domain;
  }
  cookies.save(key, value, {
    path: '/',
    expires: new Date(2034, 1, 1),
    maxAge: 315360000,
    domain: opts?.domain,
  });
};

export const removeCookies = (key: string, opts?: { domain?: string }) => {
  // @ts-ignore
  if (import.meta.env.DEV) {
    delete opts?.domain;
  }
  cookies.remove(key, {
    path: '/',
    domain: opts?.domain,
  });
};
